
import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import AnnexesListView from "./annexes-list.html";
import AnnexesEditView from "./annexes-edit.html";

angular.module("annexes", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('annexes', {
                url: "/annexes",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })
            .state('annexes.list', {
                url: "/list",
                controller: "AnnexesListCtrl",
                template: AnnexesListView,
                data: { pageTitle: 'Anexos' }
            })
            .state('annexes.edit', {
                url: "/edit/:id",
                controller: "AnnexesEditCtrl",
                template: AnnexesEditView,
                data: { pageTitle: 'Anexos' }
            })
            ;
    }])
    ;